const lang = {
    hi: {
        name: "हिंदी",
        search: "खोज",
        gptSearchPlaceholder: "आज आप क्या देखना चाहेंगे?",
    },
    en: {
        name: "English",
        search: "Search",
        gptSearchPlaceholder: "What would you like to watch today?",
    }
};

export default lang;